import React, { useState } from "react";
import DatePicker from "react-date-picker";
import { firestore } from "../../firebase/config";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DonationReportDetails from "./ReportDetails";
import { useHistory } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import "./DateRangeDonationReport.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import {
  getFirestore,
  collectionGroup,
  query,
  where,
  getDocs,
  doc,
  collection,
  getDoc,
} from "firebase/firestore";
// import GetDonorField from "../utilities/GetDonorField";
const columns = [
  {
    name: "Sl. No.",
    selector: (row) => row.srNo,
    wrap: true,
  },
  {
    name: "Pre Acknowledgement Number",
    selector: (row) => row.preAckNo,
    wrap: true,
  },
  {
    name: "ID Code",
    selector: (row) => row.idCode,
  },
  {
    name: "Unique Identification Number",
    selector: (row) => row.uniqueIdNo,
    wrap: true,
  },
  {
    name: "Section Code",
    selector: (row) => row.sectionCode,
  },
  {
    name: "Unique Registration Number (URN)",
    selector: (row) => row.urn,
  },
  {
    name: "Date of Issuance of Unique Registration Number",
    selector: (row) => row.urnDate,
  },
  {
    name: "Name of donor",
    selector: (row) => row.donorName,
    sortable: true,
  },

  {
    name: "Address of donor",
    selector: (row) => row.donorAddress,
    wrap: true,
  },
  {
    name: "Donation Type",
    selector: (row) => row.donationType,
  },

  {
    name: "Mode of receipt",
    selector: (row) => row.mode,
  },
  {
    name: "Amount of donation (Indian rupees)",
    selector: (row) => row.amount,
    sortable: true,
  },
  {
    name: "Trust",
    selector: (row) => row.trust,
  },
];
function Form10BDReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [donationDetails, setDonationDetails] = useState(null);
  const [foundNoRecord, setFoundNoRecord] = useState(false);
  const [totalDonationAmount, setTotalDonationAmount] = useState(0);
  const [trust, setTrust] = useState("CREST");
  const history = useHistory();

  const handleBackButton = (e) => {
    history.push("/donorreporthome");
    e.preventDefault();
  };
  /**
   * Retrieves the full name of a donor based on the provided reference.
   * @param {string} ref - The reference to the donor document.
   * @returns {Promise<string|null>} - A promise that resolves with the donor's full name or null if the document doesn't exist.
   */
  async function getDonorFieldData(ref, fieldName) {
    try {
      const collectionDonor = collection(firestore, "donors");
      const docRef = doc(collectionDonor, ref);
      const snapShot = await getDoc(docRef);

      if (snapShot.exists()) {
        // Split the field name by dots to handle nested properties
        const fieldNames = fieldName.split(".");
        // Initialize the value with the entire object
        let value = snapShot.data();
        // Traverse through each part of the field name
        for (const part of fieldNames) {
          if (value && value.hasOwnProperty(part)) {
            value = value[part];
          } else {
            // Property not found, return null
            value = null;
            break;
          }
        }
        return value;
      } else {
        return null; // Return null if the document doesn't exist
      }
    } catch (e) {
      console.log(`Error in Form10BDReport.jsx getDonorFieldData: ${e}`);
      console.log(e);
      return null;
    }
  }

  function removeAllOccurrences(inputStr, charToRemove) {
    const regex = new RegExp(charToRemove, "g");

    return inputStr.replace(regex, "");
  }

  const searchDonations = async () => {
    setIsLoading(true);
    setTotalDonationAmount(0); //Reset to zero
    if (donationDetails !== null) setDonationDetails(null);
    setFoundNoRecord(false);

    toDate.setHours(23);
    const db = getFirestore();

    try {
      const q = query(
        collectionGroup(db, "donations"),
        where("date", ">=", fromDate),
        where("date", "<=", toDate),
        where("type", "==", "Donation"),
        where("onRecord", "==", true),
        where("trust", "==", trust)
      );
      const querySnapShot = await getDocs(q);
      let donationArray = [];
      if (!querySnapShot.empty) {
        // console.log(querySnapShot.docs[0]);
        let counter = 1;
        for (let i = 0; i < querySnapShot.docs.length; i++) {
          const donation = querySnapShot.docs[i];
          // console.log(donation.ref.parent.parent.id);
          let donorId = donation.ref.parent.parent.id;
          const donationData = donation.data();
          setTotalDonationAmount(
            (prevAmount) => parseInt(prevAmount) + parseInt(donationData.amount)
          );
          // GetDonorField

          let donorData = {
            fullName: await getDonorFieldData(donorId, "fullName"),
            addressLine1: await getDonorFieldData(
              donorId,
              "address.addressLine1"
            ),
            addressLine2: await getDonorFieldData(
              donorId,
              "address.addressLine2"
            ),
            city: await getDonorFieldData(donorId, "address.city"),
            state: await getDonorFieldData(donorId, "address.state"),
            country: await getDonorFieldData(donorId, "address.country"),
            pin: await getDonorFieldData(donorId, "address.pin"),
            pan: await getDonorFieldData(donorId, "pan"),
          };
          let donorAddress = `${donorData.addressLine1} ${donorData.addressLine2} ${donorData.city} ${donorData.state} ${donorData.country} ${donorData.pin}`;

          donorAddress = removeAllOccurrences(donorAddress, ",");
          let mode =
            donation.data().mode === "Cash"
              ? "Cash"
              : "Electronic modes including account payee cheque/draft";
          let donationType =
            donation.data().purpose === "Object Of Trust"
              ? "Specific grant"
              : "Corpus";

          let donorIndex = donationArray.findIndex(
            (donationToFind) =>
              donationToFind.donorId === donorId &&
              donationToFind.donationType === donationType
          );
          if (donorIndex > -1) {
            donationArray[donorIndex].amount =
              parseInt(donationArray[donorIndex].amount) +
              parseInt(donation.data().amount);
          } else {
            donationArray.push({
              donorId: donorId,
              srNo: counter++,
              preAckNo: "",
              idCode: "Permanent Account Number",
              uniqueIdNo: donorData.pan,
              sectionCode: "Section 80G",
              urn: "AABTC8218MF20211",
              urnDate: "02/Oct/2021",
              donorName: donorData.fullName,
              donorAddress: donorAddress,
              mode: mode,
              donationType: donationType,
              amount: parseInt(donation.data().amount),
              trust: donation.data().trust,
            });
          }
        } //End of  for
        setDonationDetails(donationArray);
      } else {
        setFoundNoRecord(true);
      }
    } catch (e) {
      console.log(`Form10BDReport searchDonations error ${e}`);
      console.log(e);
      alert("Failed to fetch report data. Please check your network connection or permissions.");
    } finally {
      setIsLoading(false);
    }
  }; //End of searchDonations

  const updateFromDate = (date) => {
    setFromDate(date);
    if (toDate !== null) setToDate(null);
  };
  const paginationComponentOptions = { selectAllRowsItem: true };

  const hadleTrustChange = (e) => setTrust(e.target.value);
  return (
    <>
      <div className="card p-1 mb-1">
        <button
          className="btn btn-link"
          id="backButton"
          onClick={handleBackButton}
        >
          <TiArrowBack />
          Back to Report Home Page
        </button>
        <div className="justify-content-center d-flex">
          <h2>Donations Report as per Form 10BD Format</h2>
        </div>
      </div>
      <div className="card p-1 mb-1">
        <div className="justify-content-center d-flex">
          <form
            className="align-items-center"
            onSubmit={(e) => {
              e.preventDefault();
              searchDonations();
            }}
          >
            <label className="me-2" htmlFor="fromDate">
              From:
            </label>
            <DatePicker
              value={fromDate}
              id="fromDate"
              name="fromDate"
              onChange={(date) => updateFromDate(date)}
              format="dd-MMM-yyyy"
              maxDate={new Date()}
              className="ms-1 me-1"
            />
            <label className="ms-4 me-2" htmlFor="toDate">
              To:
            </label>
            <DatePicker
              value={toDate}
              id="toDate"
              name="toDate"
              onChange={(date) => setToDate(date)}
              format="dd-MMM-yyyy"
              disabled={fromDate === null}
              minDate={fromDate}
              maxDate={new Date()}
              className="ms-1 me-1"
            />
            {/* <label className="ml-4 mr-2" htmlFor="trust">
              Trust:
            </label> */}
            <label className="ms-4 me-2">Trust:</label>
            <input
              type="radio"
              id="crestRadio"
              name="crestRadio"
              value="CREST"
              onChange={hadleTrustChange}
              checked={trust === "CREST"}
            />
            <label className="ms-2 me-2" htmlFor="crestRadio">
              CREST
            </label>
            <input
              type="radio"
              id="scssRadio"
              name="scssRadio"
              value="SCSS"
              onChange={hadleTrustChange}
              checked={trust === "SCSS"}
            />
            <label className="ms-2 me-2" htmlFor="scssRadio">
              SCSS
            </label>
            {!isLoading && (
              <button
                type="submit"
                className="ps-1 btn btn-primary ms-4"
                disabled={toDate === null}
              >
                Search
              </button>
            )}
            {isLoading && (
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Getting Data...
              </Button>
            )}
          </form>
        </div>
      </div>
      <div className="card border-top-0 rounded-0">
        <div className="card-body py-2 justify-content-center d-flex">
          <div className="card-title font-weight-bold m-0">
            {donationDetails !== null && !isLoading
              ? `Report`
              : foundNoRecord
              ? `No Record Found`
              : ``}
          </div>
        </div>

        {donationDetails !== null &&
          donationDetails.length > 0 &&
          !isLoading && (
            <>
              <div className="card-body py-2 justify-content-center d-flex">
                No of records: {donationDetails.length}
              </div>
              <div className="card-body py-2 justify-content-center d-flex">
                Total Donation Amount: {totalDonationAmount}
              </div>

              <DonationReportDetails
                data={donationDetails}
                columns={columns}
                keyField={"srNo"}
                pagination={true}
                paginationComponentOptions={paginationComponentOptions}
                filename="10BDReport"
                exportObject={donationDetails}
              />
            </>
          )}
      </div>
    </>
  );
}

export default Form10BDReport;
